import { CASES } from './constants';

/**
 * Action to update clearance memo titles in the store.
 *
 * This action is dispatched to update the clearance memo titles state in the Redux store.
 * It takes a payload containing the new clearance memo titles' data.
 *
 * @param {Object} payload - The new clearance memo titles data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateClearanceMemoTitles = (payload) => {
    return { type: CASES.UPDATE_CLEARANCE_MEMO_TITLES, payload };
};

/**
 * Action to update the clearance memo titles filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateClearanceMemoTitlesFilterForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_CLEARANCE_MEMO_TITLES_FILTER_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the clearance memo titles filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearClearanceMemoTitles = () => {
    return { type: CASES.CLEAR_CLEARANCE_MEMO_TITLES, payload: {} };
};
